import { useState, useEffect } from "react";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import { useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { decodeToken } from "react-jwt";
import style from "../../styles/login.module.css";
import axios from "axios";
// import { FaRegCopyright } from "react-icons/fa";
const Login = () => {
   const [username, setUsername] = useState("");
   const [password, setPassword] = useState("");
   const [idError, setIdError] = useState("");
   const [passwordError, setPasswordError] = useState("");
   const apiUrl = process.env.REACT_APP_URL_DIR || 'http://3.14.80.174/api/'
   // console.log('process.env.REACT_APP_URL_DIR: ', process.env.REACT_APP_URL_DIR);
   const { login } = useContext(AuthContext);
   const navigate = useNavigate();
   function isCapsLockOn(event) {
      const caps = event.getModifierState && event.getModifierState('CapsLock');
      // console.log('¿Está el bloqueo de mayúsculas activado?', caps);
      if (caps){
         setPasswordError("Bloqueo de Mayusculas activado")
      } else {
         setPasswordError("")
      }
    }
    
    document.addEventListener('mouseenter',isCapsLockOn);
    document.addEventListener('keydown',isCapsLockOn);
   const logUser = async (data) => {
      try {
         // console.log('data: ', data);
         const response = await axios.post(apiUrl + "login", data); // Replace with your API endpoint
         if (!response) {
            setPasswordError("Error en red");
         }
         // console.log('response.data: ', response.data);
         login(data.token, decodeToken(response.data.token));
         localStorage.setItem("token",response.data.token);
         localStorage.setItem("refreshToken", response.data.refreshToken);
         localStorage.setItem("user", data.username);
         // console.log('decodeToken(data.username): ', decodeToken(response.data.token));
         navigate("/");
      } catch (error) {
         setPasswordError('Clave Invalida')
         localStorage.clear("token");
         throw error;
         // console.log("error" ,error);
         //   if (error.response.status === 422){
         //      setPasswordError(error.response.data.errors[0].msg)
         //   }
         //   if (error.response.status === 401){
         //     setPasswordError(error.response.data.message)
         //  }
      }
   };

   const { mutate, isLoading } = useMutation({
      mutationFn: (data) => logUser(data),
   });

   useEffect(() => {
      localStorage.clear("token");
   }, []);

   const handleSubmit = (e) => {
      e.preventDefault();
      setIdError();
      setPasswordError('')

      // alert("Boton!!")
      if ("" === username) {
         setIdError("Por favor ingrese su ID");
         return;
      }

      if ("" === password) {
         setPasswordError("Por favor ingrese su clave");
         return;
      }

      if (password.length < 1) {
         setPasswordError("La clave debe tener unminimo de 8 caracteres");
         return;
      }

      mutate({ username, password });
      // if (error) {
      //    alert(error.response.status);
      // }
   };

   return (
      <div className={style.logcontainer}>

      <form onSubmit={handleSubmit} className={style.logform}>
         <div className={style.contenedor}>
            {/* <div className={style.bckimg}>
               <img className={style.imagenes} src={ImagenTP} alt=""></img>
            </div> */}
            <div className={style.containerLogin}>
               <div className={style.titleContainer}>
                  <div>
                     <h1>Tattoo & Piercings</h1>
                  </div>
               </div>
               <br />

               <div className={style.inputContainer}>
                  <input
                     value={username}
                     placeholder="Ingrese su id"
                     onChange={(e) => setUsername(e.target.value)}
                     className={style.inputBox}
                     autoFocus
                     />
                  <p className={style.errormsg}>{idError}</p>
               </div>
               <br />
               <div className={style.inputContainer}>
                  <input
                     type="password"
                     value={password}
                     className={style.inputBox}
                     placeholder="Ingrese su clave de acceso"
                     onChange={(e) => setPassword(e.target.value)}
                  />
                  <p className={style.errormsg}>{passwordError}</p>
               </div>
               <br />
               <div className={style.btnlogin}>
                  <button
                     type="submit"
                     disabled={isLoading}
                     className={style.inputBtnNew}
                  >
                     {isLoading ? "Cargando..." : "Login"}
                  </button>
               </div>
            </div>
            {/* <div className={style.bckimg}>
               <img className={style.imagenesright} src={ImagenTP1} alt=""></img>
            </div> */}
         </div>
         {/* <div className={style.footer}>
            <h2 className={style.copyright}>Copyrights<FaRegCopyright /> RONAH</h2>
         </div> */}
      </form>
                  </div>
      /*  
    <div>
      <h1>Login</h1>
      <form onSubmit={handleSubmit}>
        <label>
          Email:
          <input type="text" value={username} onChange={(e) => setUsername(e.target.value)} />
        </label>
        <label>
          Password:
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
        </label>
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Cargando...' : 'Login'}
        </button>
        {error && <p style={{ color: 'red' }}>{error.message}</p>}
      </form>
    </div>*/
   );
};

export default Login;
